var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import Texto from '../texto/texto';
import ConenidoVentana from './contenido-ventana';

var IconoEnunciado = function IconoEnunciado(_ref) {
  var src = _ref.src;
  return React.createElement('img', {
    src: src,
    style: {
      display: 'inline-block'
    },
    alt: ''
  });
};

IconoEnunciado.propTypes = process.env.NODE_ENV !== "production" ? {
  src: t.string
} : {};
var ContenidoTipoVideo = (_temp = _class = function (_Component) {
  _inherits(ContenidoTipoVideo, _Component);

  function ContenidoTipoVideo(props) {
    _classCallCheck(this, ContenidoTipoVideo);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleAnterior = function () {
      var onAnterior = _this.props.onAnterior;
      onAnterior && onAnterior();
    };

    _this.handleSiguiente = function () {
      var onSiguiente = _this.props.onSiguiente;
      onSiguiente && onSiguiente();
    };

    _this.handleVideoEnded = function () {
      var _this$props = _this.props,
          autoplay = _this$props.autoplay,
          zonaSiguiente = _this$props.zonaSiguiente;
      var video = _this.videoRef.current;
      video.pause();
      video.currentTime = 0;
      autoplay && zonaSiguiente && window.setTimeout(function () {
        return _this.handleSiguiente();
      }, 3000);
    };

    _this.componentDidMount = function () {
      _this.videoRef.current.load();
    };

    _this.videoRef = React.createRef();
    return _this;
  }

  ContenidoTipoVideo.prototype.render = function render() {
    var _props = this.props,
        archivo = _props.archivo,
        titulo = _props.titulo,
        autoplay = _props.autoplay,
        numVideo = _props.numVideo,
        numVideosCarrusel = _props.numVideosCarrusel,
        icoEnunciado = _props.icoEnunciado,
        enunciado = _props.enunciado,
        icoExtra = _props.icoExtra,
        subtitulos = _props.subtitulos,
        carpeta = _props.carpeta;
    return React.createElement(ConenidoVentana, null, React.createElement('div', {
      className: 'proyectorVideo'
    }, React.createElement('div', {
      className: 'cabeceraVideo'
    }, React.createElement('div', {
      className: 'enunciadoVideo'
    }, icoEnunciado && React.createElement(IconoEnunciado, {
      src: '' + carpeta + icoEnunciado + '.png'
    }), enunciado && React.createElement(Texto, {
      texto: enunciado
    }), icoExtra && icoExtra.map(function (ico, index) {
      return React.createElement(IconoEnunciado, {
        key: 'icoExtra-' + index,
        src: '' + carpeta + ico + '.png'
      });
    })), React.createElement('div', {
      className: 'controlVideos'
    }, numVideosCarrusel > 1 && React.createElement('div', {
      className: 'navegacionVideoI' + (numVideo === 1 ? ' desactivado' : ''),
      onClick: this.handleAnterior
    })), React.createElement('div', {
      className: 'tituloVideo'
    }, titulo && React.createElement(Texto, {
      texto: titulo
    })), React.createElement('div', {
      className: 'controlVideos'
    }, numVideosCarrusel > 1 && React.createElement('div', {
      className: 'navegacionVideoD' + (numVideo === numVideosCarrusel ? ' desactivado' : ''),
      onClick: this.handleSiguiente
    }))), React.createElement('div', {
      className: 'contenedorVideo'
    }, React.createElement('video', {
      ref: this.videoRef,
      controls: true,
      controlsList: 'nodownload',
      autoPlay: autoplay ? "autoplay" : '',
      onLoadedMetadata: function onLoadedMetadata(e) {
        e.target.currentTime = 1 / 48;
      },
      onEnded: this.handleVideoEnded,
      src: '' + carpeta + archivo + '.mp4'
    }, subtitulos && subtitulos.map(function (subtitulo, index) {
      var props = _extends({}, subtitulo, {
        src: '' + carpeta + subtitulo.src
      });

      return React.createElement('track', _extends({
        key: 'subtitulo-' + index,
        kind: 'subtitles'
      }, props));
    })), this.props.children), React.createElement('div', {
      className: 'pieVideo'
    })));
  };

  return ContenidoTipoVideo;
}(Component), _class.defaultProps = {
  autoplay: false,
  carpeta: 'contenido/videos/',
  onAnterior: false,
  onSiguiente: false
}, _temp);
ContenidoTipoVideo.propTypes = process.env.NODE_ENV !== "production" ? {
  autoplay: t.bool,
  archivo: t.string,
  numVideo: t.number,
  numVideosCarrusel: t.number,
  titulo: t.string,
  carpeta: t.string,
  enunciado: t.string,
  zonaSiguiente: t.any,
  subtitulos: t.arrayOf(t.object),
  icoExtra: t.arrayOf(t.string),
  icoEnunciado: t.string,
  onAnterior: t.oneOfType([t.bool, t.func]),
  onSiguiente: t.oneOfType([t.bool, t.func]),
  children: t.any
} : {};
export default ContenidoTipoVideo;